/** A connector product id broken into the parts a person actually reads. */
export interface ParsedSourceProductId {
  /** Merchant offer id / retailer id — the part people search for. */
  offerId: string;
  /** Market country code (e.g. `US`, `UK`) when the id encodes one. */
  country: string | null;
  /** Content language (e.g. `en`) when the id encodes one. */
  language: string | null;
  /** The full id as the connector sent it (tooltip / copy). */
  raw: string;
}

/**
 * Parses a connector's product id into offer id + market. Handles Merchant Center's
 * `accounts/<n>/products/<lang>~<COUNTRY>~<offerId>`, its bare `<lang>~<COUNTRY>~<offerId>`
 * form, and plain ids (Meta retailer ids), so tables can show "offer · market" instead of
 * a 50-character path.
 */
export function parseSourceProductId(id: string | null | undefined): ParsedSourceProductId | null {
  if (!id) return null;
  const tail = id.includes('/products/') ? id.slice(id.lastIndexOf('/products/') + 10) : id;
  const parts = tail.split('~');
  if (parts.length >= 3) {
    const [language, country, ...rest] = parts;
    return {
      offerId: rest.join('~'),
      country: country ?? null,
      language: language ?? null,
      raw: id,
    };
  }
  return { offerId: tail, country: null, language: null, raw: id };
}
